import styled from 'styled-components';

export const PageRoot = styled.div`
  height: 100%;
  min-height: 600px;
  display: flex;
  flex-direction: column;
  font-family: var(--body);
  font-size: 18px;
  background: #0f1714;
  color: #f0e8d8;
  overflow: hidden;

  *,
  *::before,
  *::after {
    box-sizing: border-box;
  }
`;

export const MainArea = styled.div`
  flex: 1;
  display: flex;
  overflow: hidden;
  position: relative;
`;
